<template>
  <v-btn
    v-bind="$attrs"
    v-on="mergedListeners"
    :icon="typeIcon"
    :color="color"
    :outlined="outlined">
    <v-icon small :class="[{'mr-2': !typeIcon}]">{{ icon }}</v-icon>
    {{ label }}
    <slot />
  </v-btn>
</template>

<script>
import { trackGaEvent } from '@/utils/analytics';

export default {
  name: 'Button',
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    outlined: {
      type: Boolean,
      default: false
    },
    typeIcon: {
      type: Boolean,
      default: false
    },
    ga: {
      type: Object,
      default: null,
    },
  },
  computed: {
    mergedListeners() {
      const listeners = { ...this.$listeners };
      const userClick = listeners.click;
      listeners.click = (e) => {
        this.trackGaIfConfigured('click');
        if (userClick) {
          if (Array.isArray(userClick)) {
            userClick.forEach((fn) => fn(e));
          } else {
            userClick(e);
          }
        }
      };
      return listeners;
    },
  },
  methods: {
    trackGaIfConfigured(hook) {
      const cfg = this.ga;
      if (!cfg || typeof cfg !== 'object' || !cfg.event) return;
      if ((cfg.trigger || 'click') !== hook) return;
      const params = { ...cfg };
      delete params.event;
      delete params.trigger;
      trackGaEvent(cfg.event, params);
    },
  },
};
</script>

<style>

</style>
